import * as _ from "lodash";
declare var XLSX;

import { action, observable, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { ProjectMember } from "./models/project-member";


export class AdminStore{
	@observable loading = false;
	@observable csvContent = null;


	@action async fetchOptInEmail(headers : Array<string>) {
		this.loading = true;
		let result = await Agent.Admin.getOptIn();
		runInAction(() => {
			this.csvContent = this.ExportCsv(headers, result);
			this.loading = false;
		});
	}

	@action async fetchPurgeList(headers : Array<string>, filename: string) {
		this.loading = true;
		let result = await Agent.Admin.getPurgeList();
		runInAction(() => {
			this.loading = false;
		});
		this.ExportXlsx(result, filename, headers);
	}


	@action async fetchJamPurgeList( filename: string) {
		const headers = ["Survey Id", "Project Id", "Project Name", "Application Name", "Project Manager", "Purgeable?", "Purged"];
		const list = ["surveyId", "projectId", "projectName", "linkLocation", "manager"];
		this.loading = true;
		let result = await Agent.Admin.getJamPurgeList();

		const newArr = result.map(item => {
			let newItem = {};
			list.map(key => {
				return newItem[key] = item[key] ? item[key] : "";
			});
			return newItem;
		});

		runInAction(() => {
			this.loading = false;
		});
		this.ExportXlsx(newArr, filename, headers);
	}

	async fetchCodingList(surveyId) {
		let result = await Agent.Admin.getCodingInfo(surveyId);
		return result;
	}

	async fetchCodingFile(taskId) {
		let result = await Agent.Admin.getCodingResponse(taskId);
		return result;
	}

	ExportXlsx(data, fileName, headers) {
		const worksheet  = XLSX.utils.json_to_sheet(data);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		/* fix headers */
		XLSX.utils.sheet_add_aoa(worksheet, [headers], { "origin": "A1" });

		XLSX.writeFile(workbook, `${fileName}.xlsx`);
	}

	ExportCsv(headers : Array<string>, data) {
		let csvContent = "";
		let header = headers.join(",");
		csvContent = header + "\r\n";
		data.forEach(resp => {
			let row = "";
			headers.forEach(key => {
				if (resp.hasOwnProperty(key)) {
					let element = resp[key];
					if (row.length != 0) {
						row += ",";
					}
					row += element ? element : "";
				}
				else{
					row += " ";
				}
			});
			csvContent += row + "\r\n";
		});
		return csvContent;
	}
}



// WEBPACK FOOTER //
// ./src/stores/admin-store.ts